<template>
    <div class="question-single-vote-box mr-3 position-relative">
        <div class="question-vote">
            <el-button @click="handleClickVote('up')" class="question-vote-btn question-upvote-btn" :class="isUpVoted ? 'active-vote' : ''" :disabled="isDownVoted">
                <el-icon><CaretTop /></el-icon>
            </el-button>
            <input v-model="voteCount" type="text" disabled class="question-vote-count">
            <el-button @click="handleClickVote('down')" class="question-vote-btn question-downvote-btn" :class="isDownVoted ? 'active-vote' : ''" :disabled="isUpVoted">
                <el-icon><CaretBottom /></el-icon>
            </el-button>
        </div>
        <div class="question-vote-extra-btns text-center">
            <el-button class="bookmark-btn" @click="isBookmarked=!isBookmarked" :class="isBookmarked ? 'active' : ''">
                <el-icon v-if="isBookmarked"><StarFilled /></el-icon>
                <el-icon v-else><Star /></el-icon>
            </el-button>
            <el-button class="activity-btn"><el-icon><DataLine /></el-icon></el-button>
        </div>
    </div>
</template>


<script>
import { CaretTop, CaretBottom, Star, DataLine, StarFilled } from '@element-plus/icons-vue'

export default {
    name: 'QuestionVote',
    components: {
        CaretTop,
        CaretBottom,
        Star,
        DataLine,
        StarFilled,
    },
    data() {
        return {
            voteCount: '0',
            isUpVoted: false,
            isDownVoted: false,
            isBookmarked: false
        }
    },
    methods: {
        handleClickVote(e) {
            if (e == 'up') {
                if (!this.isUpVoted ==true) {
                    this.voteCount++;
                    this.isUpVoted = true;
                    this.isDownVoted = false;
                } else {
                    this.voteCount--;
                    this.isUpVoted = false;
                    this.isDownVoted = false;
                }
            } else {
                if (!this.isDownVoted ==true){
                    this.voteCount--;
                    this.isUpVoted = false;
                    this.isDownVoted = true;
                } else {
                    this.voteCount++;
                    this.isUpVoted = false;
                    this.isDownVoted = false;
                }
            }
        }
    }
}
</script>